<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/quality/inspection/method/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('jianyanfangshibianma')">
            <el-input v-model="yt.conditions.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('jianyanfangshimingcheng')">
            <el-input v-model="yt.conditions.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('jianyanleixing')">
            <yi_dictionary_select :max="999" multiple clearable="false" :type="'QUALITY_INSPECTION_TYPE'" :ids.sync="yt.conditions.inspectionTypes">
            </yi_dictionary_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }}
            </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" @click="yt.showEditDialog('xinzeng', null, 'w1'); setDefaultValue(); getProcedureCode()" type="primary" v-if="utils.checkPower('web_quality_management_inspection_method_create')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '检验方式-新增检验方式' } }">
          {{ $t('xinzeng') }}
        </el-button>
        <el-button size="mini" @click="show = !show" plain v-if="utils.checkPower('web_quality_management_inspection_method_batchImport')">
          {{ $t('daoru') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <!-- 自定义某个字段 -->
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row, 'w1'); getProcedureCode()" v-if="utils.checkPower('web_quality_management_inspection_method_upate')">
              {{ $t('bianji') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger" v-if="utils.checkPower('web_quality_management_inspection_method_delete')" @click="yt.remove(scope.row, '/web/quality/inspection/method/delete')">
              {{ $t('shanchu') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('jianyanfangshibianma')" required>
            <el-input v-model="yt.editObj.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('jianyanfangshimingcheng')" required>
            <el-input v-model="yt.editObj.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('jianyanleixing')" required>
            <yi_dictionary_select :max="1" clearable="false" :type="'QUALITY_INSPECTION_TYPE'" :ids.sync="yt.editObj.inspectionType">
            </yi_dictionary_select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/quality/inspection/method/create', beforeNewAdd)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item class="noborder" :label="$t('jianyanfangshibianma')" required>
            <el-input disabled v-model="yt.editObj.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('jianyanfangshimingcheng')" required>
            <el-input v-model="yt.editObj.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('jianyanleixing')" required>
            <yi_dictionary_select :max="1" clearable="false" :type="'QUALITY_INSPECTION_TYPE'" :ids.sync="yt.editObj.inspectionType">
            </yi_dictionary_select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/quality/inspection/method/update')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 导入excel -->
    <import-excel :show.sync="show" />
  </div>
</template>
<script type="text/javascript">
import importExcel from './import_excel'
export default {
  name: 'web_quality_management_inspection_method_list',
  components: {
    importExcel
  },
  data() {
    return {
      show: false,
      codeAndDesc: '',
      columns: [
        {
          label: 'jianyanfangshibianma',
          prop: 'code',
          width: 180,
        }, {
          label: 'jianyanfangshimingcheng',
          prop: 'name',
          width: 180,
        }, {
          label: 'jianyanleixing',
          prop: 'inspectionType',
          type: 'dictionary',
          key: 'QUALITY_INSPECTION_TYPE',
          width: 150
        },
        // {
        //   label: 'jianyanleixing',
        //   type: 'slot',
        //   width: 150
        // },
        {
          label: 'chuangjianren',
          prop: 'createByObject.nickname',
          width: 150,
        }, {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time',
          // width: 150,
        }, {
          label: 'caozuo',
          type: 'slot',
          width: 150,
          fixed: 'right'
        }]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.get(1);
      this.utils.event_hub.$on('QUALITY_MANAGEMENT_METHOD_REFRESH', () => {
        this.yt.get(1);
      })
    }, 300);
  },
  methods: {
    getProcedureCode() {
      this.http.get('/web/craft/basic/work/procedure/list').then(res => {
        this.codeAndDesc = res.data;
        if (this.yt.editObj.action == 'xinzeng') {
          this.yt.editObj.basicWorkProcedureId = this.codeAndDesc[0].id;
        }
      })
    },
    // setDefaultValue() {
    //   this.yt.editObj.inspectionType = 1
    //   // this.yt.editObj.enabled = 1
    //   this.yt.editObj.enabled = true
    // }
  },
};
</script>
